<template>
  <div>
    <div class="flex justify-between mb-2">
      <SegmentSelector v-model="segment" />
    </div>

    <div
      v-if="question === 7"
      class="ml-80 pl-2 flex justify-between text-xs text-gray-700"
    >
      <div>
        <font-awesome-icon
          :icon="['fas', 'long-arrow-alt-right']"
          class="transform rotate-180"
        />
        ninguna influencia
      </div>
      <div>
        influencia determinante
        <font-awesome-icon :icon="['fas', 'long-arrow-alt-right']" />
      </div>
    </div>

    <HeatMap
      :data="heatmapData"
      :categories="categories"
      :color-range="colors"
      :rotate-headers="question === 12"
      :class="{ 'mt-12': question === 12 }"
    />
  </div>
</template>

<script>
import HeatMap from "@/components/HeatMap";
import data from "@/assets/data/data";
import IDS from "@/utils/ids";
import SegmentSelector from "@/components/SegmentSelector";

import { group } from "d3";

export default {
  components: {
    HeatMap,
    SegmentSelector,
  },
  props: {
    question: {
      type: Number,
      required: true,
    },
    order: {
      type: Object,
      required: true,
    },
    colors: {
      type: Array,
      default: undefined,
    },
    defaultOrder: {
      type: Number,
      default: 0,
    },
    orderDir: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      data: data[this.question].filter(
        (e) =>
          e[IDS.QUESTION_SUBNUMBER] === "" &&
          e[IDS.ANSWER] !== IDS.NSNC &&
          e[IDS.ANSWER] !== IDS.OTRO_MEDICO
      ),
      segment: "TOTAL",
    };
  },
  computed: {
    heatmapData() {
      return Array.from(group(this.data, (d) => d[IDS.QUESTION_OPTION]))
        .map(([key, value]) => ({
          name: key, //.slice(0, -11), // remove " (Completa)" from name
          values: value
            .sort((a, b) =>
              this.order[b[IDS.ANSWER]] > this.order[a[IDS.ANSWER]] ? -1 : 1
            )
            .map((e) => e[IDS[this.segment]]),
        }))
        .sort(
          (a, b) =>
            (b.values[this.defaultOrder] > a.values[this.defaultOrder]
              ? 1
              : -1) * this.orderDir
        );
    },
    categories() {
      return Array.from(group(this.data, (d) => d[IDS.QUESTION_OPTION]))[0][1]
        .sort((a, b) =>
          this.order[b[IDS.ANSWER]] > this.order[a[IDS.ANSWER]] ? -1 : 1
        )
        .map((e) => e[IDS.ANSWER]);

      // .map(
      //   ([key, value]) => ({
      //     name: key, //.slice(0, -11), // remove " (Completa)" from name
      //     values: value
      //       .sort((a, b) => +a[IDS.ANSWER] - +b[IDS.ANSWER])
      //       .map((e) => e[IDS[this.segment]]),
      //   })
      // );
    },
  },
};
</script>

<style></style>
